import { CombinedGraphQLErrors } from '@apollo/client';

import { ERROR_CODES } from '@/adapters/graphql/errorCodes';

export interface LoginAuthErrorShape {
  key: string;
  detail?: string;
}

const USER_DISABLED_SUBJECT = 'user_disabled';
const ACCOUNT_LOCKED_SUBJECT = 'account_locked';

const mapGraphQLErrorsToLoginAuthError = (
  errors: readonly { extensions?: Record<string, unknown> }[],
): LoginAuthErrorShape | null => {
  const first = errors[0];
  const extensions = first?.extensions;

  if (!extensions) {
    return null;
  }

  const code = extensions['code'];
  const subject = extensions['subject'];

  if (code === ERROR_CODES.FailedPrecondition && subject === USER_DISABLED_SUBJECT) {
    return { key: 'auth.errors.userDisabled' };
  }

  // Locked after too many failed attempts; a password reset is what clears the lock
  if (code === ERROR_CODES.FailedPrecondition && subject === ACCOUNT_LOCKED_SUBJECT) {
    return { key: 'auth.errors.accountLocked' };
  }

  return null;
};

export const mapUnknownLoginError = (error: unknown): LoginAuthErrorShape => {
  if (CombinedGraphQLErrors.is(error)) {
    const mapped = mapGraphQLErrorsToLoginAuthError(error.errors);

    if (mapped) {
      return mapped;
    }
  }

  const detail = error instanceof Error ? error.message : undefined;

  return { key: 'auth.errors.loginFailed', detail };
};
